import { useAoApi } from "@lending/lib/api";

function useEvaluateConsumerDocumentsMutation() {
  const $aoApi = useAoApi();

  return $aoApi.useMutation(
    "post",
    "/v2/account_opening/consumer/applications/{uuid}/evaluate_documents/"
  );
}

export { useEvaluateConsumerDocumentsMutation };
